import React, { useState, useEffect, useRef } from 'react';
import { strings } from 'src/localization';
import * as css from './PrevRecomm.module.scss';
import AdditionalService from 'src/components/AdditionalServices/AdditionalService/containers/AdditionalService';
import { CustMode } from 'src/enums';
import classNames from 'classnames';


export interface IProps {
    custMode: CustMode,
    theme: string,
}

const PrevRecomm = (props: IProps) => {
    const [recommStatus, setRecommSatus] = useState(0);
    const prevCardRef = useRef<HTMLDivElement>(null);

    const summaryTitleClass = classNames(
        css.summaryTitle,
        {
            [css.summaryTitleBMW]: props.theme === 'bmw',
            [css.summaryTitleBuick]: props.theme === 'buick',
            [css.summaryTitleDodge]: props.theme === 'dodge',
            [css.summaryTitleIN]: props.theme === 'infiniti',
            [css.summaryTitleMazda]: props.theme === 'mazda',
            [css.summaryTitleGenesis]: props.theme === 'genesis',
            [css.summaryTitleAcura]: props.theme === 'acura',
        },
    );
    let recallMsgCSS = css.recallMsg;
    if (props.theme==='bmw') {
        recallMsgCSS = css.recallMsgBMW;
    }

    const prevRecomm =
        (
            <div id='prevRecomm' ref={prevCardRef}>
                {recommStatus !== 0 ?
                    <div id='prevRecommCard'>
                        <hr className={css.topHr} />
                        <h4 className={summaryTitleClass}>{strings.PrevRecomm}</h4>
                        <div id='RecommDiv' className={recallMsgCSS}>
                            {strings.PrevRecommSvc} {strings.SelPrevRecomm}
                        </div>
                    </div> :
                    <div id='RecommDiv3'></div>
                }
                <div id='RecommDiv2' className={recommStatus !== 0 ? css.addtnlSvcBrdr : ''}>
                    <div className={recommStatus !== 0 ? css.addtnlSvc : ''}>
                        <AdditionalService type='Recommended' vehLayoutCard setRecommStatus={setRecommSatus} />
                    </div>
                </div>
            </div>
        );

    useEffect(() => {
        const timer = setTimeout(() => {
            if (prevCardRef.current && props.custMode === CustMode.ViewRecSvcs) {
                prevCardRef.current.scrollIntoView({behavior: 'smooth'});
            }
        }, 500);

        return () => {
            clearTimeout(timer);
        };
    }, [props.custMode]);

    return prevRecomm;
};

export default PrevRecomm;